module.exports = __webpack_public_path__ + "static/img/aiClothes.ffd69a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ai_beauty/aiClothes.png
// module id = O136
// module chunks = 1